function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}

jQuery(window).bind("load", function () {
    if (jQuery('#choice_1_1_1').length > 0) {
        setTimeout(function () {
            jQuery('#choice_1_1_1').trigger('click');
        }, 200);
    }
});

(function ($) {
    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();

    /* Document ready functions */
    $(document).ready(function () {

        $(".datepicker").attr("autocomplete", "off");

        // Apply style to a if touch device
        if (isTouchDevice()) {
            $('a').addClass('mobile');
            $('a').removeClass('desktop');
        } else {
            $('a').addClass('desktop');
            $('a').removeClass('mobile');
        }

        window.sr = ScrollReveal();
        sr.reveal('.puff-section .grid .puff-item', {duration: 1000});

        $(window).scroll(function () {
            $(".top-section .section-txt").css("opacity", 1 - $(window).scrollTop() / 400);
        });

        // Smooth scroll to anchor
        $(document).on('click', '.section a[href^="#"]', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 500);
        });

        // Top section heights
        $('.top-section .swiper-slide').css({"height": windowHeight * 0.7});
        $(".top-section .section-txt").each(function () {
            var txt_margin = $(this).outerHeight() / 2;
            $(this).css({"margin-top": -txt_margin});
        });


    });

    $(window).resize(function () {

        // Get Window Width and Height on resize
        windowWidth = $(window).outerWidth();
        windowHeight = $(window).height();

        // Top section heights
        $('.top-section .swiper-slide').css({"height": windowHeight * 0.7});
        $(".top-section .section-txt").each(function () {
            var txt_margin = $(this).outerHeight() / 2;
            $(this).css({"margin-top": -txt_margin});
        });


    });

})(jQuery);
